var map = {
	"./01.jpg": 1525,
	"./02.jpg": 1526,
	"./03.jpg": 1527,
	"./04.jpg": 1528,
	"./05.jpg": 1529,
	"./06.jpg": 1530,
	"./07.jpg": 1531,
	"./08.jpg": 1532,
	"./09.jpg": 1533,
	"./10.jpg": 1534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1524;